<template>
  <div class="locale-content">
    <div class="bloc validation">
      <checkbox class="shadow" v-model="checked"
                :disabled="!canAgree"
                :val="checked"
                :text="'<span class=&quot;bolder&quot;>En cochant cette case,</span> je confirme être majeur et avoir pris connaissance des conditions générales d’utilisation et de confidentialité de CAnnect.'"
      />
      <v-button :on-click="onclick" class="button" :disabled="!!!checked">
        <span>Continuer vers CAnnect</span>
      </v-button>
    </div>
  </div>
</template>

<script>
import VButton from '@/components/shared/VButton'
import Checkbox from '@/components/shared/Checkbox'

export default {
  name: 'GeneralConditionValidateFr',
  components: { VButton, Checkbox },
  props: {
    canAgree: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: false
    }
  },
  methods: {
    onclick() {
      if (this.canAgree && this.checked === true) {
        this.$emit('onAgree')
      }
    }
  }
}
</script>
